<template>
<div class="navigate-info" v-if="currentObj.text">
  <div class="content" v-if="processText(currentObj.text) === 'continue'">
    <div class="icon">
      <img src="/image/navigate/straight-white.svg" />
    </div>
    <div class="info">
      <div class="distance">
        <span v-if="currentObj.distance > 5" :class="{'mr10': currentObj.distance > 5}">{{ $t("navigate.distanceMsg", { distance: formatDistance(currentObj.distance) }) }}</span>
        <span class="strong">{{ $t('navigate.continue') }}</span>
      </div>
      <div class="street" v-if="currentObj.street_name">
        <span>{{ $t('navigate.enter') }}</span>
        <span class="strong ml10">{{ currentObj.street_name }}</span>
      </div>
    </div>
  </div>
  <div class="content" v-else-if="processText(currentObj.text) === 'turn-right'">
    <div class="icon">
      <img src="/image/navigate/turn-right-white.svg"  />
    </div>
    <div class="info">
      <div class="distance">
        <span v-if="currentObj.distance > 5" :class="{'mr10': currentObj.distance > 5}">{{ $t("navigate.distanceMsg", { distance: formatDistance(currentObj.distance) }) }}</span>
        <span class="strong">{{ $t('navigate.turnRight') }}</span>
      </div>
      <div class="street" v-if="currentObj.street_name">
        <span>{{ $t('navigate.enter') }}</span>
        <span class="strong ml10">{{ currentObj.street_name }}</span>
      </div>
    </div>
  </div>
  <div class="content" v-else-if="processText(currentObj.text) === 'turn-left'">
    <div class="icon">
      <img src="/image/navigate/turn-right-white.svg" class="reverse"  />
    </div>
    <div class="info">
      <div class="distance">
        <span v-if="currentObj.distance > 5" :class="{'mr10': currentObj.distance > 5}">{{ $t("navigate.distanceMsg", { distance: formatDistance(currentObj.distance) }) }}</span>
        <span class="strong">{{ $t('navigate.turnLeft') }}</span>
      </div>
      <div class="street" v-if="currentObj.street_name">
        <span>{{ $t('navigate.enter') }}</span>
        <span class="strong ml10">{{ currentObj.street_name }}</span>
      </div>
    </div>
  </div>
  <div class="content" v-else-if="processText(currentObj.text) === 'turn-slight-left'">
    <div class="icon">
      <img src="/image/navigate/left-front-white.svg"  />
    </div>
    <div class="info">
      <div class="distance">
        <span v-if="currentObj.distance > 5" :class="{'mr10': currentObj.distance > 5}">{{ $t("navigate.distanceMsg", { distance: formatDistance(currentObj.distance) }) }}</span>
        <span class="strong">{{ $t('navigate.turnSlightLeft') }}</span>
      </div>
      <div class="street" v-if="currentObj.street_name">
        <span>{{ $t('navigate.enter') }}</span>
        <span class="strong ml10">{{ currentObj.street_name }}</span>
      </div>
    </div>
  </div>
  <div class="content" v-else-if="processText(currentObj.text) === 'turn-slight-right'">
    <div class="icon">
      <img src="/image/navigate/left-front-white.svg" class="reverse"  />
    </div>
    <div class="info">
      <div class="distance">
        <span v-if="currentObj.distance > 5" :class="{'mr10': currentObj.distance > 5}">{{ $t("navigate.distanceMsg", { distance: formatDistance(currentObj.distance) }) }}</span>
        <span class="strong">{{ $t('navigate.turnSlightRight') }}</span>
      </div>
      <div class="street" v-if="currentObj.street_name">
        <span>{{ $t('navigate.enter') }}</span>
        <span class="strong ml10">{{ currentObj.street_name }}</span>
      </div>
    </div>
  </div>
  <div class="content" v-else-if="processText(currentObj.text) === 'turn-sharp-right'">
    <div class="icon">
      <img src="/image/navigate/right-back-white.svg"  />
    </div>
    <div class="info">
      <div class="distance">
        <span v-if="currentObj.distance > 5" :class="{'mr10': currentObj.distance > 5}">{{ $t("navigate.distanceMsg", { distance: formatDistance(currentObj.distance) }) }}</span>
        <span class="strong">{{ $t('navigate.turnSharpRight') }}</span>
      </div>
    </div>
  </div>
  <div class="content" v-else-if="processText(currentObj.text) === 'turn-sharp-left'">
    <div class="icon">
      <img src="/image/navigate/right-back-white.svg" class="reverse" />
    </div>
    <div class="info">
      <div class="distance">
        <span v-if="currentObj.distance > 5" :class="{'mr10': currentObj.distance > 5}">{{ $t("navigate.distanceMsg", { distance: formatDistance(currentObj.distance) }) }}</span>
        <span class="strong">{{ $t('navigate.turnSharpLeft') }}</span>
      </div>
    </div>
  </div>
  <div class="content" v-else-if="processText(currentObj.text) === 'finish'">
    <div class="icon">
      <img src="/image/navigate/end.svg" />
    </div>
    <div class="info" v-if="currentObj.distance < 5">
      <div class="distance">
        <span class="strong">{{ $t('navigate.arriveInfo') }}</span>
      </div>
    </div>
    <div class="info" v-else>
      <div class="distance">
        <span>{{ $t("navigate.distanceMsg", { distance: formatDistance(currentObj.distance) }) }}</span>
        <span class="strong"> {{ $t('navigate.finish') }}</span>
      </div>
    </div>
  </div>
  <div class="content" v-else>
    <div class="info">
      <div class="distance">
        <span v-if="currentObj.distance > 5">{{ $t("navigate.distanceMsg", { distance: formatDistance(currentObj.distance) }) }}</span>
        <span class="strong">{{ currentObj.text }}</span>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      currentObj: { text: '' }
    }
  },
  methods: {
    formatDistance (val) {
      let s = ''
      if (val < 1000) {
        s = Math.round(val) + this.$t('common.metre')
      } else {
        s = Math.round(parseInt(val * 10) / 1000) / 10
        s += this.$t('common.kilometre')
      }
      return s
    },
    processText (text) {
      const string = text.toLowerCase()
      if (/continue/.test(string)) {
        return 'continue'
      } else if (/turn right/.test(string)) {
        return 'turn-right'
      } else if (/turn left/.test(string)) {
        return 'turn-left'
      } else if (/turn slight right/.test(string)) {
        return 'turn-slight-right'
      } else if (/turn slight left/.test(string)) {
        return 'turn-slight-left'
      } else if (/turn sharp left/.test(string)) {
        return 'turn-sharp-left'
      } else if (/turn sharp right/.test(string)) {
        return 'turn-sharp-right'
      } else if (/finish/.test(string)) {
        return 'finish'
      } else {
        return text
      }
    },
    displayText (obj) {
      this.currentObj = obj
    }
  }
}
</script>

<style lang="scss" scoped>
.navigate-info {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #37bceb;
  padding: 20px 30px;
  z-index: 30;
  .content {
    display: flex;
    align-items: center;
  }
  .icon {
    flex-shrink: 0;

    img {
      display: block;
      &.reverse {
        transform: rotateY(180deg);
      }
    }
  }

  .info {
    flex: 1;
    margin-left: 30px;
    font-size: 16px;
    line-height: 32px;
    color: rgba(255, 255, 255, 0.8);

    .strong {
      color: #ffffff;
    }

    .ml10 {
      margin-left: 10px;
    }

    .mr10 {
      margin-right: 10px;
    }
  }
}
</style>
